import gql from "graphql-tag";

export default gql`
  query UserAssetStatusByTickerSymbol($tickerSymbol: TickerSymbol!, $country: SecurityCountry!) {
    issuerByTickerSymbol(tickerSymbol: $tickerSymbol, country: $country) {
      ... on AmericanCompanyIssuer {
        _id
        isInPortfolio
        viewerDidBookmark
      }
      ... on BrazilianCompanyIssuer {
        _id
        isInPortfolio
        viewerDidBookmark
      }
      ... on BrazilianRealEstateFund {
        _id
        isInPortfolio
        viewerDidBookmark
      }
    }
  }
`;
